import { US_CITY_EDITORIAL_CANDIDATES } from "./us-city-expansion-content.mjs";

// Finite candidate dispositions, not a publishing authorization. Admission
// also requires fresh certified inventory and the full document/browser gate.
// The eleven unsupported bounded captures are deliberately absent.
const candidatePaths = new Set([
  "/classic-car-rental-denver", "/classic-car-rental-new-york",
  "/classic-car-rental-minneapolis", "/classic-car-rental-st-louis",
  "/classic-car-rental-charlotte", "/classic-car-rental-portland",
  "/classic-car-rental-indianapolis", "/classic-car-rental-kansas-city",
  "/classic-car-rental-columbus",
]);
export const US_CITY_EXPANSION_LINKS = US_CITY_EDITORIAL_CANDIDATES
  .filter(city => candidatePaths.has(city.path))
  .map(city => ({ label: city.city, href: city.path, section: "Featured destinations", image: city.hero.url }));

/** Catalog membership alone never authorizes a public link. */
export function activeUsCityExpansionLinks(admissions, now = Date.now()) {
  if (!Array.isArray(admissions)) return [];
  return US_CITY_EXPANSION_LINKS.filter(link => admissions.some(admission =>
    admission?.href === link.href && Number.isFinite(Date.parse(admission.expiresAt)) &&
    Date.parse(admission.expiresAt) > now));
}
